import React from 'react';

const CertificateImage = () => {
  return (
    <div className="flex w-full flex-col items-center justify-center bg-white px-4 py-10">
      {/* Heading */}
      <h1 className="mb-6 text-center font-manrope text-[24px] font-extrabold capitalize leading-[30px] text-[#000000] md:text-[48px] md:leading-[54px]">
        Internship Certificate
      </h1>

      {/* Certificate Image */}
      <img
        src={'/images/Certificate-skillq.png'}
        alt="Internship Certificate"
        className="h-auto w-full rounded-lg md:max-w-[1024px]"
      />
    </div>
  );
};

export default CertificateImage;
